import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0b1096d8"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ml-8" }, "元", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_FormDialog = _resolveComponent("FormDialog")!

  return (_openBlock(), _createBlock(_component_FormDialog, {
    ref: "formDialogRefs",
    title: "调账",
    width: "600px",
    labelWidth: "120px",
    formData: _ctx.editFormData,
    rules: _ctx.rules,
    showErrorToast: false,
    validateOnRuleChange: false,
    visible: _ctx.visibleRef,
    "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.visibleRef) = $event)),
    saveForm: _ctx.saveFormHandle,
    confirmBtnText: "确定"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_form_item, {
        label: "运单号",
        prop: "billCode"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_input, {
            placeholder: "",
            disabled: "",
            modelValue: _ctx.editFormData.billCode,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.editFormData.billCode) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      (_ctx.dealTypeRef !== 3)
        ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 0,
            label: "调账类型",
            prop: "dictName"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                placeholder: "",
                disabled: "",
                modelValue: _ctx.editFormData.dictName,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.editFormData.dictName) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_el_form_item, {
        label: "调账费用",
        prop: "fee"
      }, {
        default: _withCtx(() => [
          (_ctx.dealType !== 3)
            ? (_openBlock(), _createBlock(_component_el_input_number, {
                key: 0,
                class: "input-num",
                min: 0.0,
                max: 999999.99,
                placeholder: "请输入调账费用",
                modelValue: _ctx.editFormData.fee,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.editFormData.fee) = $event)),
                precision: 2,
                controls: false
              }, null, 8, ["min", "max", "modelValue"]))
            : (_openBlock(), _createBlock(_component_el_input_number, {
                key: 1,
                class: "input-num",
                min: -99999.0,
                max: 99999.0,
                placeholder: "请输入调账费用",
                modelValue: _ctx.editFormData.fee,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.editFormData.fee) = $event)),
                precision: 2,
                controls: false
              }, null, 8, ["min", "max", "modelValue"])),
          _hoisted_1
        ]),
        _: 1
      }),
      _createVNode(_component_el_form_item, {
        label: "备注",
        prop: "remark"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_input, {
            type: "textarea",
            placeholder: "请输入备注信息",
            rows: "3",
            resize: "none",
            maxlength: "100",
            "show-word-limit": "",
            modelValue: _ctx.editFormData.remark,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.editFormData.remark) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["formData", "rules", "visible", "saveForm"]))
}